
import { IconProps, Stack } from "@chakra-ui/react";
import { ChevronDownIcon } from "./ChevronDown";
import { ChevronUpIcon } from "./ChevronUp";

export function ChevronOpenVertical(props: IconProps) {
  return (
    <Stack spacing={0}>
      <ChevronUpIcon {...props}/>
      <ChevronDownIcon {...props}/>
    </Stack>
  );
}
